<template>
  <div class="qc-platform-ui" v-if="props.show">
    <div class="qc-forgot-password-modal-warp">
      <div class="qc-playform-overlay"></div>
      <div class="qc-playform-layout">
        <Header closeBtnIcon="retrun_btn" :closeHandle="props.onClose" />
        
        <div class="qc-playform-content qc-forgot-password-content">
          <div class="qc-title qc-text-center">找回密码</div>
          <div class="qc-playform-form">
            <div class="qc-form-item">
              <div class="qc-form-item-label">
                <div class="qc-sprites qc-sprites-phone_icon"></div>
              </div>
              <div class="qc-form-input">
                <input type="text"
                  style="width: 100%;"
                  placeholder="请输入手机号"
                  name="phone"
                  v-model.trim="phone"
                  autocomplete="off"
                  @focus="() => onFocus(1)"
                  @blur="onBlur" />
              </div>
            </div>
            <div class="qc-form-item qc-code-form-item">
              <div class="qc-form-item-label">
                <div class="qc-sprites qc-sprites-safe_icon"></div>
              </div>
              <div class="qc-form-input">
                <input
                  type="text"
                  v-model.trim="code"
                  placeholder="请输入验证码"
                  name="code"
                  autocomplete="off"
                  @focus="() => onFocus(2)"
                  @blur="onBlur" />
              </div>
              <div class="qc-form-operation">
                <div v-if="canSendCode" class="qc-send-code-text" @click="sendCode()">发送验证码</div>
                <div v-else class="qc-send-code-disable">{{ countdown + 's 后重发' }}</div>
              </div>
            </div>
            <div class="qc-form-item">
              <div class="qc-form-item-label">
                <div class="qc-sprites qc-sprites-password_icon"></div>
              </div>
              <div class="qc-form-input">
                <input :type="showPassword ? 'text' : 'password'"
                  placeholder="请输入密码"
                  name="password"
                  v-model.trim="password"
                  autocomplete="off"
                  @focus="() => onFocus(3)"
                  @blur="onBlur" />
              </div>
              <div class="qc-form-operation" @click="togglePassword()">
                <div v-if="showPassword" class="qc-sprites qc-sprites-password_show_icon"></div>
                <div v-else class="qc-sprites qc-sprites-password_hide_icon"></div>
              </div>
            </div>
            <div :class="'qc-default-btn qc-confirm-btn ' + (isFormInvalid ? 'qc-disable-btn' : '')" @click="onConfirm()">确认</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed } from 'vue';
import { Toast } from '../../subComponents/Toast/index';
import Header from '../../subComponents/Header/index.vue';
import ApiManager from '../../core/api/index';
import { VERIFY_CODE_TYPE, VERIFY_CODE_CHANNEL } from '../../core/constants/index';
import type { DomesticForgotPasswordProps } from '../types';

const props = withDefaults(defineProps<DomesticForgotPasswordProps>(), {});

const phone = ref('');
const code = ref('');
const password = ref('');
const captchaVerifyCode = ref('');

const phoneError = computed(() => {
  if (!phone.value) {
    return '请输入手机号';
  }
  if (!new RegExp('^\\+{0,1}[0-9]+$').test(phone.value)) {
    return '请输入正确的手机号';
  }
});
const codeError = computed(() => {
  if (!code.value) {
    return '请输入验证码';
  }
  if (!new RegExp("^\\d{6}$").test(code.value)) {
    return '请输入正确的验证码';
  }
});
const passwordError = computed(() => {
  if (!password.value) {
    return '请输入密码';
  }
  if (!new RegExp('^[0-9A-Za-z_/+!@#:\\{\\}\\|%;\\^\\&\\*-]{6,20}$').test(password.value)) {
    return '密码格式不正确';
  }
});

const showPassword = ref(false);
const togglePassword = () => {
  showPassword.value = !showPassword.value;
};
// 高亮的表单行
const hightLightFormItem = ref(0);
// 表单聚焦
const onFocus = (rowIdx?: number) => {
  rowIdx && (hightLightFormItem.value = rowIdx);
};
const onBlur = () => {
  hightLightFormItem.value = 0;
};

const isFormInvalid = computed(() => {
  return !!phoneError.value || !!codeError.value || !!passwordError.value;
});

// 倒计时
let interval: any;
const countdown = ref(60);
const canSendCode = ref(true);
const countDown = () => {
  if (countdown.value <= 0) {
    countdown.value = 60;
    canSendCode.value = true;
    clearInterval(interval);
  } else {
    --countdown.value;
  }
};

// 加载阿里云二次验证
const initAliyunCaptcha = (SceneId: string, EncryptedSceneId: string) => {
  if (!window.initAliyunCaptcha) {
    Toast("图形验证码加载失败，请刷新页面重试");
    return;
  }
  window.initAliyunCaptcha({
    SceneId,
    EncryptedSceneId,
    mode: "popup",
    element: "#captcha-element",
    success: function (captchaVerifyParam: string) {
      captchaVerifyCode.value = captchaVerifyParam;
      sendCode();
    },
    fail: function () {},
    onClose: function () {},
    getInstance: function (instance: any) {
      instance.show();
    },
  });
};

// 发送验证码
const sendCode = async () => {
  // 没有填写手机号
  if (phoneError.value) {
    Toast(phoneError.value);
    return;
  }
  canSendCode.value = false;

  await ApiManager.getInstance().user.sendVerificationCode({
    type: VERIFY_CODE_TYPE.PHONE,
    channel: VERIFY_CODE_CHANNEL.RESET_PASSWORD,
    number: phone.value,
    captcha_verify_param: captchaVerifyCode.value || '',
  }).then((response) => {
    if (response.code === 200) {
      Toast('发送成功');
      interval = setInterval(countDown, 1000);
      captchaVerifyCode.value = '';
    } else if (response.code === 407) {
      const { captcha_encrypted_scene_id, captcha_scene_id } = response.metadata;
      canSendCode.value = true;
      captchaVerifyCode.value = '';
      initAliyunCaptcha(captcha_scene_id, captcha_encrypted_scene_id);
    } else {
      canSendCode.value = true;
      Toast(response.message);
    }
  }).catch((error) => {
    canSendCode.value = true;
    Toast(error.message);
  });
};

const onConfirm = async () => {
  if (phoneError.value) {
    Toast(phoneError.value);
    return;
  } else if (codeError.value) {
    Toast(codeError.value);
    return;
  } else if (passwordError.value) {
    Toast(passwordError.value);
    return;
  }

  await ApiManager.getInstance().user.resetPassword({
    account: phone.value,
    code: code.value,
    password: password.value
  }).then((response) => {
    if (response.code === 200) { // 登录成功
      Toast('密码修改成功');
      props.onClose();
    } else {
      Toast(response.message);
    }
  }).catch((error) => {
    Toast(error.message);
  });
};

</script>
<style lang="less">
</style>